import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const NewsException = styled.div`
  display: block;
  margin: 86px auto 124px auto;

  > img {
    margin: 0 auto 32px auto;
    display: flex;
    width: 328px;
    height: 328px;
  }

  > p {
    margin: 0;
    text-align: center;
    font-size: 18px;
    line-height: 26px;
    color: ${COLOR.gray50};
    font-family: NotoSansRegular, sans-serif;
  }

  ${customMedia.lessThan('tablet')`
      margin: 58px auto 150px auto;
      > img{
        width: 200px;
        height : 200px;
        margin: 0 auto 6px auto;
      }
      > p{
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;}
      
`}
`

const NewsWrap = styled.div`
  display: block;
  margin: 0 auto 240px auto;
  ${customMedia.lessThan('tablet')`
    width: 100%;
    max-width:600px;
    margin: 0 auto 124px auto;
`}
`
const NewsItemList = styled.a`
  display: grid;
  grid-template-columns: 356px 356px 356px;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 15px;
  padding-bottom: 9px;
  ${customMedia.lessThan('tablet')`
    grid-template-columns: 49% 49%;
    margin: 0 0 60px 0;
    gap: 13px;
`}
  ${customMedia.lessThan('mobile')`
    gap: 7px;
`}
`
const NewsItem = styled.a`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 282px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);
  border-radius: 20px;

  ${customMedia.lessThan('tablet')`
   height: 300px;
  `}

  ${customMedia.lessThan('tablet_cut_line')`
   height: 170px;
  `}
`
const NewsTitle = styled.h4`
  margin: 16px 17px 0px 17px;
  font-weight: 500;
  white-space: normal;
  line-height: normal;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;

  ${customMedia.lessThan('tablet')`
    font-size: 13px;
`}

  ${customMedia.lessThan('tablet_cut_line')`
    font-size: 10px;
    margin: 10px;
`}
`

const NewsImg = styled.img`
  display: flex;
  border-radius: 20px 20px 0 0;
  width: 100%;
  height: 202px;
  object-position: center center;
  object-fit: cover;

  ${customMedia.lessThan('tablet')`
   height: 219px;
  `}

  ${customMedia.lessThan('tablet_cut_line')`
   height: 122px;
  `}
`

export { NewsException, NewsImg, NewsItem, NewsItemList, NewsTitle, NewsWrap }
